module.exports = __webpack_public_path__ + "images/security-9f9db500.svg";